import { useEffect, useRef, useState } from "react";

interface CountUpProps {
	target: number;
	duration?: number;
	className?: string;
	formatter?: (value: number) => string;
}

export function CountUp({ target, duration = 1000, className, formatter }: CountUpProps) {
	const [value, setValue] = useState(0);
	const rafRef = useRef<number>(0);

	useEffect(() => {
		const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
		if (prefersReduced) {
			setValue(target);
			return;
		}

		const start = performance.now();
		const animate = (now: number) => {
			const elapsed = now - start;
			const progress = Math.min(elapsed / duration, 1);
			// Ease-out curve
			const eased = 1 - (1 - progress) ** 3;
			setValue(Math.round(eased * target));

			if (progress < 1) {
				rafRef.current = requestAnimationFrame(animate);
			}
		};

		rafRef.current = requestAnimationFrame(animate);
		return () => cancelAnimationFrame(rafRef.current);
	}, [target, duration]);

	const display = formatter ? formatter(value) : String(value);

	return <span className={className}>{display}</span>;
}
